import { GetStaticPropsContext } from 'next';

import { LoggedInHomepage as LoggedInHomepageNoGql } from './pages/HomepageLoggedIn';
import { LoggedOutHomepage as LoggedOutHomepageNoGql } from './pages/HomepageLoggedOut';
import { initializeApollo, graphQLWrapper } from '@zoopla/apollo';
import HOMEPAGE_QUERY from './queries/homepage.query';
import { HomepageQuery } from './queries/homepage.query.generated';
import { logInfo } from '@zoopla/logger';

export const LoggedInHomepage = graphQLWrapper(LoggedInHomepageNoGql);
export const LoggedOutHomepage = graphQLWrapper(LoggedOutHomepageNoGql);

export async function getStaticProps(_ctx: GetStaticPropsContext) {
    if (typeof window === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const newrelic = require('newrelic');
        newrelic.setTransactionName(`/`);
    }

    const apolloClient = initializeApollo(null);

    try {
        const homepage = await apolloClient?.query<HomepageQuery>({
            query: HOMEPAGE_QUERY,
            variables: {
                articleLimit: 12
            }
        });
        const homepageData = homepage?.data?.homepage || {};

        return {
            props: {
                ...homepageData
            },
            revalidate: 600 // 10 mins
        };
    } catch (error) {
        const logLine = {
            level: 50,
            message: 'error on the homepage',
            page: 'homepage',
            error: error
        };
        logInfo(JSON.stringify(logLine));
        return {
            props: {},
            revalidate: 300
        };
    }
}
